<!--<div (click)="showOverviewModal=true">Click me to see success</div> -->

<app-modal [showModal]='showOverviewModal'  id="reportSuccessPopup">
    <div class="modal-header">
        <h2 id='modalHeading'>Request report </h2>
    </div>
    <div class="corner-button">
        <button class="close" aria-label="Close" (click)="btnAction(true)" (keydown)="btnAction(true, $event)">x</button>
    </div>
    <div class="alert valign-children-middle" *ngIf="requestReceived">
        <div class="alert-success">
            <i class="icon-approval" role="img" aria-label="Success"></i>
        </div>
        <div><h2>We received your request.</h2>
            <p>We're processing your request. We will send you an email when processing is complete.</p></div>
        <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="Close"></div>
    </div>
    <div class="box-outer">
        <div class="segment">
            <div><label class="center-block">Report type</label> </div>
            <div><label class="center-block" id="type">{{report.type}}</label>
            </div>
        </div>
          <div class="segment">
        <div><label class="center-block">Report format</label> </div>
        <div><label class="center-block" id="format">{{report.format}}</label>
        </div>
    </div>
     </div>
    <div class="text-right modal-footer">
        <div class="button-group">
            <a href="javascript:void(0)" role="button" class="btn btn-secondary pull-right" (click)="btnAction(true)"  (keydown)="btnAction(true, $event)"  attr.aria-label="Continue">OK</a>
            <!--<a href="javascript:void(0)" class="btn btn-link"  (click)="btnAction(false)" attr.aria-label="Cancel}">Cancel</a>-->
        </div>
        <div class="clearfix"></div>
    </div>

</app-modal>